import React from 'react';

import { ContentType, GridAssembly } from 'src/api/contentful/contentTypes.cloverdotcom';
import { getField } from 'src/utils/EntryUtil';

import { ContentfulEntry, ContentfulEntryRenderProps } from '../EntryLoader/ContentfulEntry';
import { GridModule } from '../GridModule/GridModule';
import { useSalesChannel } from '../SalesChannel/SalesChannel';
import { useShopFooter } from './UseShopFooter';

export const DEFAULT_RESELLER_GRID_ENTRY_ID = '5gmbEwXqohvj8OxLVonWfL';

export const ResellerGrid: React.FC = () => {
  const { salesChannel } = useSalesChannel();

  if (!salesChannel) {
    return (
      <ContentfulEntry entryId={DEFAULT_RESELLER_GRID_ENTRY_ID} contentType={ContentType.GRID_ASSEMBLY}>
        {({ entry }: ContentfulEntryRenderProps<GridAssembly>) => {
          const backgroundColor = getField(entry, 'backgroundColor');
          return <GridModule entry={entry} style={{ backgroundColor }} />;
        }}
      </ContentfulEntry>
    );
  }

  const shoppingFooter = getField(salesChannel, 'shoppingFooter');
  if (!shoppingFooter) return null;

  const gridAssembly = useShopFooter(shoppingFooter);
  if (!gridAssembly) return null;

  const backgroundColor = getField(gridAssembly, 'backgroundColor');

  return (
    <GridModule entry={gridAssembly} style={{ backgroundColor }} />
  );
};
